import React, { useCallback, useEffect, useState } from 'react';
import { Abwesenheiten } from '../components/kanzlei/Abwesenheiten';
import { useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import { api, useAuth } from '../context/AuthContext';
import { Toaster } from '../components/ui/sonner';
import { TeamRechte } from '../components/kanzlei/rechte/TeamRechte';
import { RollenMatrix } from '../components/kanzlei/rechte/RollenMatrix';
import { MandantenKonten } from '../components/kanzlei/rechte/MandantenKonten';
import { RechteProtokoll } from '../components/kanzlei/rechte/RechteProtokoll';
import AdminTeam from './AdminTeam';
import { KontenZusammenfuehren } from '../components/kanzlei/rechte/KontenZusammenfuehren';
import { MandantAnlegenAktionen } from '../components/kanzlei/MandantAnlegenAktionen';

const TABS = [['team', 'Kanzlei-Team'], ['rollen', 'Rollen'], ['mandantenkonten', 'Mandantenkonten'], ['protokoll', 'Protokoll']];

export default function KanzleiBenutzer() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') || 'team';
  const [katalog, setKatalog] = useState(null);
  const laden = useCallback(() => api.get('/kanzlei/rechte/katalog').then((r) => setKatalog(r.data)).catch(() => setKatalog(false)), []);
  useEffect(() => { laden(); }, [laden]);
  return (
    <div className="min-h-screen bg-[#f5f8fa] bg-[radial-gradient(circle_at_1px_1px,rgba(27,58,92,0.07)_1px,transparent_0)] [background-size:22px_22px]" data-testid="kanzlei-benutzer">
      <Header />
      <main className="pt-[104px] lg:pt-[152px] max-w-[1300px] mx-auto px-4 lg:px-8 pb-16">
        <div className="pt-10 flex flex-wrap items-end gap-4">
          <h1 className="font-serif text-4xl sm:text-5xl text-[#1B3A5C] flex-1 min-w-[260px]">Benutzer und Rechte</h1>
          {user?.role !== 'freelancer' && <MandantAnlegenAktionen />}
        </div>
        <div className="mt-6"><Abwesenheiten /></div>
        {katalog && !katalog.darf_verwalten && <p className="text-sm text-[#34536b] mt-2" data-testid="rechte-nur-lesen">Sie sehen die Rechte nur. Ändern dürfen Konten mit dem Recht „Benutzer und Rechte verwalten“.</p>}
        <nav className="mt-6 flex gap-1 overflow-x-auto no-scrollbar border-b border-gray-200" aria-label="Benutzer und Rechte">
          {[...TABS, ...(user?.role === 'admin' ? [['zusammenfuehren', 'Konten zusammenführen']] : [])].map(([k, l]) => (
            <button key={k} type="button" onClick={() => setParams({ tab: k })} data-testid={`rechte-tab-${k}`} aria-current={tab === k ? 'page' : undefined}
              className={`shrink-0 px-4 py-2.5 text-[13px] border-b-2 -mb-px transition-colors ${tab === k ? 'border-[#b8893d] text-[#1B3A5C] font-medium' : 'border-transparent text-gray-500 hover:text-[#1B3A5C]'}`}>{l}</button>
          ))}
        </nav>
        <div className="mt-6">
          {katalog === false && <p className="text-sm text-rose-700">Keine Berechtigung.</p>}
          {katalog && tab === 'team' && (
            <>
              <TeamRechte katalog={katalog} />
              {user?.role === 'admin' && (
                <details className="mt-6 bg-white border border-gray-200 rounded-2xl" data-testid="rechte-zugangsdaten">
                  <summary className="cursor-pointer p-4 text-[13px] text-[#1B3A5C]">Zugangsdaten, Abteilung und Benachrichtigungen</summary>
                  <AdminTeam eingebettet />
                </details>
              )}
            </>
          )}
          {katalog && tab === 'rollen' && <RollenMatrix katalog={katalog} onSaved={laden} />}
          {katalog && tab === 'mandantenkonten' && <MandantenKonten katalog={katalog} startNr={params.get('mnr') || ''} />}
          {katalog && tab === 'protokoll' && <RechteProtokoll />}
          {user?.role === 'admin' && tab === 'zusammenfuehren' && <KontenZusammenfuehren />}
        </div>
      </main>
      <Toaster />
    </div>
  );
}
